import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./UserUpdate.css";
import FormFieldValidationError from '../../Common/FormFieldValidationError/FormFieldValidationError';
import axios from 'axios';
import {RESOURCE_BASE_URL} from "../../../configuration";
import Redirect from "react-router-dom/es/Redirect";

class UserUpdate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            role: "",
            address: "",
            phone: "",
            gender: "",
            japaneseFirstName: "",
            japaneseLastName: "",
            nameError: "",
            emailError: "",
            usernameError: "",
            phoneError: "",
            roleError: "",
            japaneseFirstNameError: "",
            japaneseLastNameError: "",
            addressError: "",
            user: [],
            redirect: false
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.validateName = this.validateName.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validateUsername = this.validateUsername.bind(this);
        this.validateRole = this.validateRole.bind(this);
        this.validateAddress = this.validateAddress.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onSelectGenderChange = this.onSelectGenderChange.bind(this);
    }

    componentDidMount() {
        axios.get(RESOURCE_BASE_URL + 'api/admins/' + this.props.match.params.id)
            .then((res) => {
                // console.log(res.data);
                this.setState({
                    name: res.data.name,
                    email: res.data.email,
                    role: res.data.roles[0],
                    address: res.data.address,
                    phone: res.data.phone,
                    japaneseFirstName: res.data.japaneseFirstName,
                    japaneseLastName: res.data.japaneseLastName,

                });
                if (res.data.gender!== null) {
                    this.setState({gender: res.data.gender[0]})
                }
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    validateName = () => {
        let name = this.state.name;
        return (name !== "" );
    };

    validateEmail = () => {
        let email = this.state.email;
        let pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

        return email.match(pattern);
    };

    validateUsername = () => {
        let username = this.state.username;
        return (username !== "" );
    };

    validateJapaneseLastName = () => {
        let japaneseLastName = this.state.japaneseLastName;
        return (japaneseLastName !== "" );
    };

    validateJapaneseFirstName = () => {
        let japaneseFirstName = this.state.japaneseFirstName;
        return (japaneseFirstName !== "" );
    };

    validateRole = () => {
        let role = this.state.role;
        return (role !== "");
    };

    validateAddress= () =>{
        let address = this.state.address;
        return(address !== "");
    };

    validatePhone = () => {
        let phone = this.state.phone;
        let pattern = /^[0-9]*$/;
        if (phone === "" || !phone.match(pattern)) {
            this.setState({
                phoneError: "app.validation.user-profile.user-add-address.empty-contact"
            });
            return false;
        }
        return true;
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            nameError: "",
            emailError: "",
            usernameError: "",
            roleError: "",
            addressError :"",
            phoneError: "",
            japaneseFirstNameError: "",
            japaneseLastNameError: ""
        });
    };

    onSelectChange = (event) => {
        this.setState({
            role: event.target.value,
            roleError: "",
        });
    };

    onSelectGenderChange =(event) => {
        this.setState({
            gender: event.target.value
        });
    };

    onSubmit = (event) => {
        let nameError = "";
        let emailError = "";
        let roleError = "";
        let addressError = "";
        let phoneError = "";
        let japaneseFirstNameError = "";
        let japaneseLastNameError = "";
        let validationPassed = true;

        if (!this.validateName(event)) {
            validationPassed = false;
            nameError = "app.validation.user-update.invalid-name";
        }
        if (!this.validateEmail(event)) {
            validationPassed = false;
            emailError = "app.validation.user-update.invalid-email";
        }

        if (!this.validateRole(event)) {
            validationPassed = false;
            roleError = "app.validation.user-update.invalid-role";
        }

        if(!this.validateAddress(event)){
            validationPassed = false;
            addressError = "app.validation.user-creation.invalid-address";
        }

        if (!this.validatePhone(event)) {
            validationPassed = false;
            phoneError = "app.validation.user-profile.user-add-address.empty-contact";
        }

        /*if (!this.validateJapaneseFirstName(event)) {
            validationPassed = false;
            japaneseFirstNameError = "app.validation.user-profile.user-add-address.empty-japanese-first-name";
        }

        if (!this.validateJapaneseLastName(event)) {
            validationPassed = false;
            japaneseLastNameError = "app.validation.user-profile.user-add-address.empty-japanese-last-name";
        }*/

        if (validationPassed) {
            // console.log("Validation passed in user update");

            let putData = {
                name: this.state.name,
                email: this.state.email,
                roles: [this.state.role],
                address: this.state.address,
                phone: this.state.phone,
                japaneseFirstName: this.state.japaneseFirstName,
                japaneseLastName: this.state.japaneseLastName,
                gender: this.state.gender
            };

            // console.log("put::",this.state.gender);

            let config = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*'
                }
            };

            axios.put(RESOURCE_BASE_URL + 'api/admins/' + this.props.match.params.id, putData, config)
                .then((res) => {
                    this.setState({
                        redirect: true
                    });
                    // console.log(res.data);
                    // console.log("User updated successfully");
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
            event.preventDefault();
        } else {
            event.preventDefault();
            this.setState({nameError, emailError, roleError, addressError, phoneError});
        }
    };

    render() {

        const {redirect} = this.state;

        if (redirect) {
            return <Redirect to='/admin/users/all'/>;
        }

        return (
            <div className="user-update-content">
                <div className="user-update-div">
                    <form onSubmit={this.onSubmit}>
                        <div className="title-1 text-align-left">
                            <FormattedMessage id="app.user-update.title"
                                              defaultMessage="UPDATE USER"
                                              description=""/>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-update.name"
                                                              defaultMessage="Name"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="name"
                                           value={this.state.name}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.nameError}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-update.email"
                                                              defaultMessage="Email"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="email"
                                           value={this.state.email}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.emailError}/>
                            </div>
                        </div>
                        {/*<div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-update.username"
                                                              defaultMessage="Username"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="username"
                                           value={this.state.username}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.usernameError}/>
                            </div>
                        </div>*/}

                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-update.japanese-first-name"
                                                              defaultMessage="Japanese First Name"
                                                              description=""/>
                                            <span className="mandatory-star"> </span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="japaneseFirstName"
                                           value={this.state.japaneseFirstName}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        {/*<div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.japaneseFirstNameError}/>
                            </div>
                        </div>*/}

                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-update.japanese-last-name"
                                                              defaultMessage="Japanese Last Name"
                                                              description=""/>
                                            <span className="mandatory-star"> </span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="japaneseLastName"
                                           value={this.state.japaneseLastName}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        {/*<div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.japaneseLastNameError}/>
                            </div>
                        </div>*/}

                        <div className="row">
                            <div className="user-creation-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.primary-address"
                                                              defaultMessage="Address"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="address"
                                           value={this.state.address}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.addressError}/>
                            </div>
                        </div>

                        {/*Phone field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.phone"
                                                              defaultMessage="Phone"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="phone"
                                           value={this.state.phone}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.phoneError}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-update.role"
                                                              defaultMessage="Role"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 no-padding-left ">
                                    <select className="form-control" name="role" value={this.state.role}
                                            onChange={this.onSelectChange}>
                                        <option value="">--Choose Role--</option>
                                        <option value="manager">Manager</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.roleError}/>
                            </div>
                        </div>

                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.gender"
                                                              defaultMessage="Gender"
                                                              description=""/>
                                            <span className="mandatory-star"> </span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 no-padding-left ">
                                    <select className="form-control" name="role" value={this.state.gender}
                                            onChange={this.onSelectGenderChange}>
                                        <option value="">--Choose Gender--</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-8 col-md-offset-2 send-password-check">
                                    <input type="checkbox"/>&nbsp;
                                    <span>
                                        <FormattedMessage id="app.user-update.send-password"
                                                          defaultMessage="Reset password"
                                                          description=""/>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2 col-md-offset-2">
                                    <button className="btn btn-success" type="submit">
                                        <FormattedMessage id="app.user-update.update"
                                                          defaultMessage="Update"
                                                          description=""/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default UserUpdate;



// WEBPACK FOOTER //
// ./src/components/Admin/UserUpdate/UserUpdate.js